import React from "react"
import {Container, Row, Col} from 'reactstrap'
import Layout from '../components/layout'
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import {Link, graphql} from "gatsby"
import SideMenu from '../components/side-menu'

// TODO: This seems to go through all the pages twice
const IndexPage = ({data}) => {
    const {edges} = data.allMdx

    return (
        <Layout showSlidingMenu={true} slidingMenuData={{category: 'All'}}>
            <Container>
                <Row>
                    <Col xl="3" className="d-none d-xl-block">
                        <SideMenu category="All"/>
                    </Col>
                    <Col xs="12" xl="9">
                        <Row>
                            {edges.map(({node}) => {
                                const {path, title, subtitle} = node.frontmatter
                                let featuredImage
                                if (node.frontmatter.featuredImage) {
                                    const image = getImage(node.frontmatter.featuredImage)
                                    featuredImage = <GatsbyImage image={image} alt={node.frontmatter.title} />
                                } else {
                                    // This is a placeholder for cases when there is no featured image provided
                                    featuredImage =
                                        <div className={'d1-project-card-image-placeholder'}>No featured image
                                            provided</div>
                                }
                                return (
                                    <Col xs="12" md="6" key={path}>
                                        <div
                                            className="d1-project-card h-100 d-flex flex-column justify-content-between">
                                            <Link to={path} className="d1-project-card--title-link">
                                                {featuredImage}
                                                <div className="d1-project-card--overlay">
                                                    <div className="d1-project-card--title-overlay">
                                                        <div
                                                            className="d1-project-card--title-overlay-title">{title}</div>
                                                        <div
                                                            className="d1-project-card--title-overlay-subtitle">{subtitle}</div>
                                                    </div>
                                                </div>
                                            </Link>
                                        </div>
                                    </Col>
                                )
                            })}
                        </Row>
                    </Col>
                </Row>
            </Container>
        </Layout>
    )
}

export default IndexPage

export const pageQuery = graphql`
    query IndexQuery {
        allMdx(
            sort: { order: DESC, fields: [frontmatter___sortOrder] }
            filter: { frontmatter: { type: { eq: "project" } } }
        ) {
            edges {
                node {
                    frontmatter {
                        title
                        subtitle
                        path
                        sortOrder
                        featuredImage {
                            childImageSharp {
                                gatsbyImageData(
                                    width: 600
                                )
                            }
                        }
                    }
                }
            }
        }
    }
`